import http from "@/common/http"

export const getDay = (city) =>{
  return http({
    url:"/cont/Weather/getDay",
    method:"get",
    data:{
      city
    }
  })
}


export default {
  getDay
}



// WEBPACK FOOTER //
// ./src/services/client/cont/weather.js